import React, { useMemo, useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

// ─────────────────────────────────────────────────────────────
// Prochaine audition — modifier ici pour les prochaines sessions
// ─────────────────────────────────────────────────────────────
const AUDITION_DATE = '2026-10-10';
const AUDITION_TIME = '13:00';
const AUDITION_END_TIME = '15:00';

// Tarif Crew (identique Ados & Adultes) — même grille que la page formation
const CREW_PRICES = { monthly: 120, semester1: 450, semester2: 670, annual: 1000, adminFee: 25 };

const FORMATION_PATH = '/formation-crew';
const FORMATION_URL = 'https://mkdstudio.co/formation-crew';

const AUDITION_LABELS = {
  fr: { date: 'samedi 10 octobre', time: 'de 13h à 15h' },
  nl: { date: 'zaterdag 10 oktober', time: 'van 13u tot 15u' },
  en: { date: 'Saturday, October 10', time: 'from 1 to 3 PM' },
};

const translations = {
  fr: {
    seoTitle: 'Audition Crew MKD - samedi 10 octobre de 13h à 15h',
    seoDescription: 'Audition gratuite pour intégrer la formation intensive Crew MKD : plus de 120h de danse et d’entraînement, voyages, shows, tournages et shootings.',
    back: '← Retour à la formation crew',
    badge: 'Audition gratuite',
    title: 'Audition Crew MKD',
    subtitle: 'Samedi 10 octobre, de 13h à 15h — l’audition pour intégrer un groupe de formation intensive.',
    cards: ['💃 +120h de danse & d’entraînement', '✈️ Voyages', '📸 Shootings & tournages', '🏆 Shows & concours'],

    groupsTitle: 'Deux groupes, le même programme',
    groups: [
      { name: 'Groupe Ados', detail: '3 à 4 dimanches par mois, en matinée' },
      { name: 'Groupe Adultes', detail: '3 à 4 dimanches par mois, l’après-midi' },
    ],
    pricingTitle: 'Tarifs de la formation (Ados & Adultes)',
    priceMonthly: 'Mensuel (domiciliation)',
    priceSemester1: 'Semestre 1 (sept.–déc.)',
    priceSemester2: 'Semestre 2 (jan.–juin)',
    priceAnnual: 'Annuel',
    perMonth: '/mois',
    adminFee: 'frais administratifs (annuel)',
    auditionFree: 'L’audition, elle, est gratuite.',
    moreInfo: 'Tu veux tout savoir sur la formation (programme, groupes, projets) ?',
    moreInfoCta: 'Voir la page de la formation Crew →',

    whyTitle: 'Pourquoi cette audition ?',
    p1: 'L’objectif est de voir le niveau et la motivation de chaque danseur afin de finaliser les groupes et de placer chacun dans le groupe le plus adapté. Nous avons 2 groupes (ados et adultes) qui s’entraînent les dimanches.',
    p2: 'Nous voulons créer un crew bienveillant, motivant et engagé, où chacun peut évoluer, progresser, se challenger et avancer avec les autres.',
    p3: 'Tous les détails pratiques sur le groupe seront aussi expliqués le jour de l’audition, et plus de détails sont disponibles sur la page Formation Crew. Pour toute question, n’hésite pas à nous contacter.',
    notice: 'Quelques jours avant l’audition, tu recevras un message avec les infos pour te préparer.',
    formTitle: 'Je m’inscris à l’audition',
    success: 'Ton inscription est confirmée 🎉 Un mail de confirmation vient d’être envoyé.',
    firstName: 'Prénom',
    lastName: 'Nom',
    birthDate: 'Date de naissance',
    danceYears: 'Nombre d’années de danse',
    phone: 'Téléphone',
    email: 'Adresse mail',
    parentTitle: 'Contact parent obligatoire',
    parentName: 'Nom du parent',
    parentPhone: 'Téléphone parent',
    parentEmail: 'Email parent',
    message: 'Message ou remarque',
    checkbox: 'En cochant cette case, je valide mon inscription à l’audition du Crew MKD et je confirme ma présence le samedi 10 octobre de 13h à 15h.',
    submit: 'Valider mon inscription',
    submitting: 'Inscription en cours...',
    minorAlert: 'Pour les mineurs, le contact parent est obligatoire.',
    checkboxAlert: 'Merci de confirmer que vous avez bien compris les informations pratiques.',
    error: 'Une erreur est survenue. Merci de réessayer.',
    emailSubject: 'Confirmation inscription audition crew MKD',
    emailGreeting: 'Bonjour',
    emailConfirmed: 'Ton inscription à l’audition du Crew MKD est bien confirmée 🎉',
    emailDate: 'Date',
    emailTime: 'Heure',
    emailPrice: 'Prix de l’audition',
    emailFree: 'Gratuit',
    emailGoalTitle: 'Objectif de l’audition',
    emailGoalText: 'Le but n’est pas de mettre la pression. L’objectif est de voir le niveau et la motivation de chaque danseur afin de finaliser les groupes et de placer chacun dans le groupe le plus adapté.',
    emailLevels: 'Cette audition permet d’intégrer la formation intensive Crew MKD : plus de 120h de danse et d’entraînement sur l’année, des voyages, des shows, des tournages vidéo, des shootings photo et des concours.',
    emailMoreInfo: 'Toutes les infos sur la formation (groupes, tarifs, projets) sont disponibles ici',
    emailImportant: 'Tous les détails pratiques sur le groupe seront expliqués le jour de l’audition. Quelques jours avant, nous enverrons aussi un message avec les informations pour se préparer.',
    recap: 'Récapitulatif',
    name: 'Nom',
    years: 'Années de danse',
    soon: 'À très bientôt',
    team: 'L’équipe MKD Studio',
  },
  nl: {
    seoTitle: 'Auditie Crew MKD - zaterdag 10 oktober van 13u tot 15u',
    seoDescription: 'Gratis auditie om deel te nemen aan de intensieve MKD Crew-opleiding: meer dan 120u dans en training, reizen, shows, video- en fotoshoots.',
    back: '← Terug naar de crew opleiding',
    badge: 'Gratis auditie',
    title: 'Auditie Crew MKD',
    subtitle: 'Zaterdag 10 oktober, van 13u tot 15u — de auditie om deel uit te maken van een intensieve opleidingsgroep.',
    cards: ['💃 +120u dans & training', '✈️ Reizen', '📸 Foto- & videoshoots', '🏆 Shows & wedstrijden'],

    groupsTitle: 'Twee groepen, hetzelfde programma',
    groups: [
      { name: 'Groep Tieners', detail: '3 tot 4 zondagen per maand, in de voormiddag' },
      { name: 'Groep Volwassenen', detail: '3 tot 4 zondagen per maand, in de namiddag' },
    ],
    pricingTitle: 'Tarieven van de opleiding (Tieners & Volwassenen)',
    priceMonthly: 'Maandelijks (domiciliëring)',
    priceSemester1: 'Semester 1 (sep–dec)',
    priceSemester2: 'Semester 2 (jan–jun)',
    priceAnnual: 'Jaarlijks',
    perMonth: '/maand',
    adminFee: 'administratiekosten (jaarlijks)',
    auditionFree: 'De auditie zelf is gratis.',
    moreInfo: 'Wil je alles weten over de opleiding (programma, groepen, projecten)?',
    moreInfoCta: 'Bekijk de pagina van de Crew-opleiding →',

    whyTitle: 'Waarom deze auditie?',
    p1: 'Het doel is om het niveau en de motivatie van elke danser te bekijken, zodat we de groepen kunnen samenstellen en iedereen in de meest geschikte groep kunnen plaatsen. We hebben 2 groepen (tieners en volwassenen) die op zondag trainen.',
    p2: 'We willen een warme, motiverende en geëngageerde crew creëren waarin iedereen kan groeien, vooruitgaan, zichzelf uitdagen en samen met de groep evolueren.',
    p3: 'Alle praktische informatie over de groep wordt ook uitgelegd op de dag van de auditie, en meer details vind je op de pagina Formation Crew. Heb je vragen? Neem gerust contact met ons op.',
    notice: 'Enkele dagen voor de auditie ontvang je een bericht met informatie om je voor te bereiden.',
    formTitle: 'Ik schrijf me in voor de auditie',
    success: 'Je inschrijving is bevestigd 🎉 Er werd een bevestigingsmail verzonden.',
    firstName: 'Voornaam',
    lastName: 'Naam',
    birthDate: 'Geboortedatum',
    danceYears: 'Aantal jaren danservaring',
    phone: 'Telefoon',
    email: 'E-mailadres',
    parentTitle: 'Contact ouder verplicht',
    parentName: 'Naam ouder',
    parentPhone: 'Telefoon ouder',
    parentEmail: 'E-mail ouder',
    message: 'Bericht of opmerking',
    checkbox: 'Door dit vakje aan te vinken, bevestig ik mijn inschrijving voor de MKD Crew-auditie en bevestig ik mijn aanwezigheid op zaterdag 10 oktober van 13u tot 15u.',
    submit: 'Mijn inschrijving bevestigen',
    submitting: 'Inschrijving bezig...',
    minorAlert: 'Voor minderjarigen is het contact van een ouder verplicht.',
    checkboxAlert: 'Gelieve te bevestigen dat je de praktische informatie goed begrepen hebt.',
    error: 'Er is een fout opgetreden. Probeer opnieuw.',
    emailSubject: 'Bevestiging inschrijving auditie Crew MKD',
    emailGreeting: 'Hallo',
    emailConfirmed: 'Je inschrijving voor de auditie van Crew MKD is bevestigd 🎉',
    emailDate: 'Datum',
    emailTime: 'Uur',
    emailPrice: 'Prijs van de auditie',
    emailFree: 'Gratis',
    emailGoalTitle: 'Doel van de auditie',
    emailGoalText: 'Het doel is niet om druk te zetten. We willen het niveau en de motivatie van elke danser bekijken om de groepen samen te stellen en iedereen in de meest geschikte groep te plaatsen.',
    emailLevels: 'Met deze auditie kan je deelnemen aan de intensieve MKD Crew-opleiding: meer dan 120u dans en training per jaar, reizen, shows, videoshoots, fotoshoots en wedstrijden.',
    emailMoreInfo: 'Alle info over de opleiding (groepen, tarieven, projecten) vind je hier',
    emailImportant: 'Alle praktische details over de groep worden uitgelegd op de dag van de auditie. Enkele dagen voordien sturen we ook een bericht met informatie om je voor te bereiden.',
    recap: 'Samenvatting',
    name: 'Naam',
    years: 'Jaren danservaring',
    soon: 'Tot binnenkort',
    team: 'Het MKD Studio team',
  },
  en: {
    seoTitle: 'MKD Crew Audition - Saturday, October 10, 1–3 PM',
    seoDescription: 'Free audition to join the intensive MKD Crew training: 120+ hours of dance and training, trips, shows, video and photo shoots.',
    back: '← Back to crew training',
    badge: 'Free audition',
    title: 'MKD Crew Audition',
    subtitle: 'Saturday, October 10, from 1 to 3 PM — the audition to join an intensive training group.',
    cards: ['💃 120+ hours of dance & training', '✈️ Trips', '📸 Photo & video shoots', '🏆 Shows & competitions'],

    groupsTitle: 'Two groups, the same programme',
    groups: [
      { name: 'Teen group', detail: '3 to 4 Sundays per month, mornings' },
      { name: 'Adult group', detail: '3 to 4 Sundays per month, afternoons' },
    ],
    pricingTitle: 'Training fees (Teens & Adults)',
    priceMonthly: 'Monthly (direct debit)',
    priceSemester1: 'Semester 1 (Sep–Dec)',
    priceSemester2: 'Semester 2 (Jan–Jun)',
    priceAnnual: 'Annual',
    perMonth: '/month',
    adminFee: 'administrative fee (yearly)',
    auditionFree: 'The audition itself is free.',
    moreInfo: 'Want to know everything about the training (programme, groups, projects)?',
    moreInfoCta: 'See the Crew training page →',

    whyTitle: 'Why this audition?',
    p1: 'The goal is to see each dancer’s level and motivation in order to finalise the groups and place everyone in the most suitable one. We have 2 groups (teens and adults) who train on Sundays.',
    p2: 'We want to build a supportive, motivating and committed crew where everyone can grow, improve, challenge themselves and move forward together.',
    p3: 'All practical details about the group will also be explained on the audition day, and more details are available on the Crew Training page. If you have any questions, feel free to contact us.',
    notice: 'A few days before the audition, you will receive a message with preparation information.',
    formTitle: 'Register for the audition',
    success: 'Your registration is confirmed 🎉 A confirmation email has been sent.',
    firstName: 'First name',
    lastName: 'Last name',
    birthDate: 'Date of birth',
    danceYears: 'Years of dance experience',
    phone: 'Phone number',
    email: 'Email address',
    parentTitle: 'Parent contact required',
    parentName: 'Parent name',
    parentPhone: 'Parent phone',
    parentEmail: 'Parent email',
    message: 'Message or note',
    checkbox: 'By checking this box, I confirm my registration for the MKD Crew audition and confirm that I will attend on Saturday, October 10, from 1 to 3 PM.',
    submit: 'Confirm my registration',
    submitting: 'Registering...',
    minorAlert: 'For minors, a parent contact is required.',
    checkboxAlert: 'Please confirm that you understood the practical information.',
    error: 'An error occurred. Please try again.',
    emailSubject: 'MKD Crew audition registration confirmation',
    emailGreeting: 'Hello',
    emailConfirmed: 'Your registration for the MKD Crew audition is confirmed 🎉',
    emailDate: 'Date',
    emailTime: 'Time',
    emailPrice: 'Audition price',
    emailFree: 'Free',
    emailGoalTitle: 'Goal of the audition',
    emailGoalText: 'The goal is not to put pressure on anyone. We want to see each dancer’s level and motivation in order to finalise the groups and place everyone in the most suitable one.',
    emailLevels: 'This audition lets you join the intensive MKD Crew training: 120+ hours of dance and training over the year, trips, shows, video shoots, photo shoots and competitions.',
    emailMoreInfo: 'All the information about the training (groups, fees, projects) is available here',
    emailImportant: 'All practical details about the group will be explained on the audition day. A few days before, we will also send a message with preparation information.',
    recap: 'Summary',
    name: 'Name',
    years: 'Years of dance',
    soon: 'See you soon',
    team: 'The MKD Studio team',
  },
};

const getAuditionLabels = (lang) => AUDITION_LABELS[lang] || AUDITION_LABELS.fr;

const buildConfirmationEmailHtml = (data, lang) => {
  const t = translations[lang] || translations.fr;
  const a = getAuditionLabels(lang);
  const fullName = `${data.firstName || ''} ${data.lastName || ''}`.trim() || '—';

  return `
<!doctype html>
<html>
  <body style="margin:0;padding:0;background-color:#f9fafb;color:#111827;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;line-height:1.5;">
    <div style="max-width:680px;margin:20px auto;background-color:#ffffff;border-radius:12px;overflow:hidden;border:1px solid #e5e7eb;box-shadow:0 4px 10px rgba(0,0,0,0.08);">
      <div style="background:linear-gradient(135deg,#6f4ef6 0%,#8b5cf6 45%,#5b45ff 100%);padding:26px;color:#ffffff;">
        <span style="background:#ffffff;color:#5b45ff;border-radius:9999px;padding:6px 12px;font-size:12px;font-weight:700;">MKD Studio</span>
        <h1 style="margin:14px 0 0 0;font-size:26px;line-height:1.3;font-weight:800;">${t.emailSubject}</h1>
      </div>
      <div style="padding:24px;background-color:#ffffff;color:#374151;">
        <p style="font-size:16px;margin-top:0;">${t.emailGreeting} ${data.firstName || ''},</p>
        <p style="font-size:16px;">${t.emailConfirmed}</p>
        <div style="background-color:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:18px;margin:20px 0;">
          <p style="margin:0 0 8px 0;"><strong>📅 ${t.emailDate} :</strong> ${a.date}</p>
          <p style="margin:0 0 8px 0;"><strong>🕐 ${t.emailTime} :</strong> ${a.time}</p>
          <p style="margin:0;"><strong>💰 ${t.emailPrice} :</strong> ${t.emailFree}</p>
        </div>
        <div style="background:#f3e8ff;border-left:5px solid #7C3AED;border-radius:10px;padding:18px;margin:20px 0;">
          <h3 style="margin:0 0 10px 0;color:#5b21b6;">${t.emailGoalTitle}</h3>
          <p style="margin:0;">${t.emailGoalText}</p>
        </div>
        <p style="font-size:16px;">${t.emailLevels}</p>
        <p style="font-size:16px;">${t.emailMoreInfo} : <a href="${FORMATION_URL}" style="color:#5b45ff;font-weight:700;">${FORMATION_URL}</a></p>
        <div style="background:#fff8e1;border:1px solid #ffd54f;border-radius:10px;padding:16px;margin:20px 0;color:#5d4037;">
          <strong>📝 Important :</strong> ${t.emailImportant}
        </div>
        <h3 style="margin:24px 0 12px 0;color:#111827;">${t.recap}</h3>
        <table style="width:100%;border-collapse:collapse;background:#ffffff;border:1px solid #e5e7eb;border-radius:8px;overflow:hidden;">
          <tbody>
            <tr><td style="padding:12px;border-bottom:1px solid #e5e7eb;"><strong>${t.name}</strong></td><td style="padding:12px;border-bottom:1px solid #e5e7eb;">${fullName}</td></tr>
            <tr><td style="padding:12px;border-bottom:1px solid #e5e7eb;"><strong>${t.birthDate}</strong></td><td style="padding:12px;border-bottom:1px solid #e5e7eb;">${data.dateOfBirth || '—'}</td></tr>
            <tr><td style="padding:12px;border-bottom:1px solid #e5e7eb;"><strong>${t.years}</strong></td><td style="padding:12px;border-bottom:1px solid #e5e7eb;">${data.danceYears || '0'}</td></tr>
            <tr><td style="padding:12px;"><strong>${t.phone}</strong></td><td style="padding:12px;">${data.phone || '—'}</td></tr>
          </tbody>
        </table>
        <p style="margin-top:24px;">${t.soon},<br/><strong>${t.team}</strong></p>
      </div>
      <div style="padding:20px 24px;background-color:#f9fafb;color:#6b7280;border-top:1px solid #e5e7eb;text-align:center;font-size:14px;">
        MKD Studio — <a href="mailto:info@mkdstudio.co" style="color:#5b45ff;text-decoration:none;">info@mkdstudio.co</a> — +32 493 88 72 88
      </div>
    </div>
  </body>
</html>`.trim();
};

const CrewAudition = () => {
  const navigate = useNavigate();
  const [lang, setLang] = useState('fr');
  const t = translations[lang] || translations.fr;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    danceYears: '',
    phone: '',
    email: '',
    parentName: '',
    parentPhone: '',
    parentEmail: '',
    message: '',
    acceptedInfo: false,
  });

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const isMinor = useMemo(() => {
    if (!formData.dateOfBirth) return false;
    const birth = new Date(formData.dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    return age < 18;
  }, [formData.dateOfBirth]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const sendConfirmationEmail = async (auditionData) => {
    const html = buildConfirmationEmailHtml(auditionData, lang);
    const recipients = [auditionData.email].filter(Boolean);

    if (auditionData.isMinor && auditionData.parentEmail) {
      recipients.push(auditionData.parentEmail);
    }

    // Important : sur certains environnements Firebase, l'écriture client dans
    // la collection "mail" peut être refusée par les règles Firestore.
    // On garde donc l'envoi du mail séparé pour ne pas bloquer l'inscription.
    return addDoc(collection(db, 'mail'), {
      to: recipients,
      message: {
        subject: t.emailSubject,
        html,
      },
      createdAt: serverTimestamp(),
      type: 'crew_audition_confirmation',
      locale: lang,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isMinor && (!formData.parentName || !formData.parentPhone)) {
      alert(t.minorAlert);
      return;
    }

    if (!formData.acceptedInfo) {
      alert(t.checkboxAlert);
      return;
    }

    setSubmitting(true);

    const auditionData = {
      ...formData,
      isMinor,
      locale: lang,
      auditionDate: AUDITION_DATE,
      auditionTime: AUDITION_TIME,
      auditionEndTime: AUDITION_END_TIME,
      status: 'new',
      source: 'website',
      createdAt: serverTimestamp(),
    };

    try {
      await addDoc(collection(db, 'crew_auditions'), auditionData);

      try {
        await sendConfirmationEmail(auditionData);
      } catch (emailError) {
        console.warn(
          'Inscription enregistrée, mais email non envoyé. Vérifie les règles Firestore de la collection mail.',
          emailError
        );
      }

      setSuccess(true);
      setFormData({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        danceYears: '',
        phone: '',
        email: '',
        parentName: '',
        parentPhone: '',
        parentEmail: '',
        message: '',
        acceptedInfo: false,
      });
    } catch (error) {
      console.error('Erreur inscription audition:', error);

      const message = error?.code === 'permission-denied'
        ? "L'inscription n'a pas pu être enregistrée à cause des règles Firestore. Autorise la création dans la collection crew_auditions."
        : t.error;

      alert(message);
    } finally {
      setSubmitting(false);
    }
  };

  const PriceRow = ({ label, value, highlight }) => (
    <div style={highlight ? { ...styles.priceRow, ...styles.priceRowHighlight } : styles.priceRow}>
      <span style={styles.priceLabel}>{label}</span>
      <span style={styles.priceValue}>{value}</span>
    </div>
  );

  return (
    <div style={styles.page}>
      <SEO title={t.seoTitle} description={t.seoDescription} />

      <section style={styles.hero}>
        <button style={styles.backButton} onClick={() => navigate(FORMATION_PATH)}>
          {t.back}
        </button>

        <div style={styles.langSwitcher}>
          {['fr', 'nl', 'en'].map((code) => (
            <button
              key={code}
              type="button"
              onClick={() => setLang(code)}
              style={code === lang ? styles.langButtonActive : styles.langButton}
            >
              {code.toUpperCase()}
            </button>
          ))}
        </div>

        <div style={styles.badge}>{t.badge}</div>
        <h1 style={styles.title}>{t.title}</h1>
        <p style={styles.subtitle}>{t.subtitle}</p>

        <div style={styles.heroCards}>
          {t.cards.map((card) => (
            <div key={card} style={styles.infoCard}>{card}</div>
          ))}
        </div>
      </section>

      <section style={styles.contentGrid}>
        <div style={styles.textBlock}>
          <h2 style={styles.sectionTitle}>{t.whyTitle}</h2>
          <p>{t.p1}</p>
          <p>{t.p2}</p>
          <p>{t.p3}</p>
          <div style={styles.notice}>{t.notice}</div>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <h2 style={styles.formTitle}>{t.formTitle}</h2>

          {success && <div style={styles.success}>{t.success}</div>}

          <div style={styles.formGrid}>
            <div>
              <label style={styles.label}>{t.firstName} *</label>
              <input name="firstName" value={formData.firstName} onChange={handleChange} required style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>{t.lastName} *</label>
              <input name="lastName" value={formData.lastName} onChange={handleChange} required style={styles.input} />
            </div>
          </div>

          <div style={styles.formGrid}>
            <div>
              <label style={styles.label}>{t.birthDate} *</label>
              <input type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange} required style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>{t.danceYears} *</label>
              <input type="number" min="0" name="danceYears" value={formData.danceYears} onChange={handleChange} required style={styles.input} />
            </div>
          </div>

          <div style={styles.formGrid}>
            <div>
              <label style={styles.label}>{t.phone} *</label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>{t.email} *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required style={styles.input} />
            </div>
          </div>

          {isMinor && (
            <div style={styles.parentBox}>
              <h3 style={styles.parentTitle}>{t.parentTitle}</h3>
              <div style={styles.formGrid}>
                <div>
                  <label style={styles.label}>{t.parentName} *</label>
                  <input name="parentName" value={formData.parentName} onChange={handleChange} required={isMinor} style={styles.input} />
                </div>
                <div>
                  <label style={styles.label}>{t.parentPhone} *</label>
                  <input type="tel" name="parentPhone" value={formData.parentPhone} onChange={handleChange} required={isMinor} style={styles.input} />
                </div>
              </div>
              <div>
                <label style={styles.label}>{t.parentEmail}</label>
                <input type="email" name="parentEmail" value={formData.parentEmail} onChange={handleChange} style={styles.input} />
              </div>
            </div>
          )}

          <div>
            <label style={styles.label}>{t.message}</label>
            <textarea name="message" value={formData.message} onChange={handleChange} rows="4" style={{ ...styles.input, minHeight: 110 }} />
          </div>

          <label style={styles.checkboxLine}>
            <input type="checkbox" name="acceptedInfo" checked={formData.acceptedInfo} onChange={handleChange} />
            <span>{t.checkbox}</span>
          </label>

          <button type="submit" disabled={submitting} style={{ ...styles.submitButton, opacity: submitting ? 0.7 : 1 }}>
            {submitting ? t.submitting : t.submit}
          </button>
        </form>
      </section>

      {/* Groupes & tarifs de la formation */}
      <section style={{ ...styles.formationSection, marginTop: 36, marginBottom: 0 }}>
        <div style={styles.formationGrid}>
          <div style={styles.groupsBox}>
            <h3 style={styles.boxTitle}>{t.groupsTitle}</h3>
            {t.groups.map((g) => (
              <div key={g.name} style={styles.groupRow}>
                <strong style={{ color: '#5B21B6' }}>{g.name}</strong>
                <span>{g.detail}</span>
              </div>
            ))}
          </div>

          <div style={styles.pricingBox}>
            <h3 style={styles.boxTitle}>{t.pricingTitle}</h3>
            <div style={{ display: 'grid', gap: 8 }}>
              <PriceRow label={t.priceMonthly} value={`${CREW_PRICES.monthly}€${t.perMonth}`} />
              <PriceRow label={t.priceSemester1} value={`${CREW_PRICES.semester1}€`} />
              <PriceRow label={t.priceSemester2} value={`${CREW_PRICES.semester2}€`} />
              <PriceRow label={t.priceAnnual} value={`${CREW_PRICES.annual}€`} highlight />
            </div>
            <p style={styles.adminFee}>+ {CREW_PRICES.adminFee}€ {t.adminFee}</p>
            <p style={styles.auditionFree}>🎟️ {t.auditionFree}</p>
          </div>
        </div>

        <div style={styles.moreInfoBox}>
          <p style={{ margin: '0 0 14px', fontWeight: 600 }}>{t.moreInfo}</p>
          <button type="button" style={styles.moreInfoButton} onClick={() => navigate(FORMATION_PATH)}>
            {t.moreInfoCta}
          </button>
        </div>
      </section>
    </div>
  );
};

const styles = {
  page: { maxWidth: 1180, margin: '0 auto', padding: '24px', color: '#1f2937' },
  hero: {
    borderRadius: 28,
    padding: '58px 24px 48px',
    background: 'linear-gradient(135deg, #7C3AED 0%, #111827 100%)',
    color: 'white',
    textAlign: 'center',
    marginBottom: 36,
    position: 'relative',
    overflow: 'hidden',
  },
  backButton: {
    position: 'absolute', top: 18, left: 18, border: '1px solid rgba(255,255,255,0.4)',
    background: 'rgba(255,255,255,0.12)', color: 'white', padding: '9px 14px', borderRadius: 999, cursor: 'pointer',
  },
  langSwitcher: { position: 'absolute', top: 18, right: 18, display: 'flex', gap: 6 },
  langButton: {
    border: '1px solid rgba(255,255,255,0.35)', background: 'rgba(255,255,255,0.1)', color: 'white',
    padding: '7px 10px', borderRadius: 999, cursor: 'pointer', fontWeight: 800,
  },
  langButtonActive: {
    border: '1px solid #FDE68A', background: '#FDE68A', color: '#111827',
    padding: '7px 10px', borderRadius: 999, cursor: 'pointer', fontWeight: 900,
  },
  badge: { display: 'inline-block', background: '#FDE68A', color: '#111827', padding: '8px 16px', borderRadius: 999, fontWeight: 800, marginBottom: 16 },
  title: { fontSize: 'clamp(2.4rem, 6vw, 4.5rem)', margin: '0 0 12px', fontWeight: 900 },
  subtitle: { fontSize: 'clamp(1.1rem, 3vw, 1.5rem)', maxWidth: 760, margin: '0 auto 26px', color: '#F3E8FF' },
  heroCards: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 14, maxWidth: 850, margin: '0 auto' },
  infoCard: { background: 'rgba(255,255,255,0.14)', border: '1px solid rgba(255,255,255,0.22)', borderRadius: 18, padding: 16, fontWeight: 700 },

  formationSection: {
    background: 'linear-gradient(135deg, #F3E8FF 0%, #FFFFFF 100%)',
    border: '2px solid #7C3AED',
    borderRadius: 24,
    padding: '32px 24px',
    marginBottom: 36,
    boxShadow: '0 10px 30px rgba(124, 58, 237, 0.1)',
  },
  formationGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 18, marginBottom: 22 },
  groupsBox: { background: 'white', borderRadius: 18, padding: 20, boxShadow: '0 4px 14px rgba(0,0,0,0.05)' },
  pricingBox: { background: 'white', borderRadius: 18, padding: 20, boxShadow: '0 4px 14px rgba(0,0,0,0.05)' },
  boxTitle: { margin: '0 0 14px', color: '#7C3AED', fontSize: '1.2rem' },
  groupRow: { display: 'grid', gap: 2, padding: '12px 14px', background: '#F9FAFB', borderRadius: 12, marginBottom: 10 },
  priceRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '9px 12px', background: '#F9FAFB', borderRadius: 10 },
  priceRowHighlight: { background: '#EFEDFF', border: '1px solid #7C3AED' },
  priceLabel: { fontSize: '0.88rem', color: '#444', fontWeight: 500 },
  priceValue: { fontSize: '1.02rem', fontWeight: 800, color: '#7C3AED' },
  adminFee: { margin: '10px 0 0', fontSize: '0.8rem', color: '#888', fontStyle: 'italic', textAlign: 'center' },
  auditionFree: { margin: '8px 0 0', fontSize: '0.9rem', fontWeight: 700, color: '#166534', textAlign: 'center' },
  moreInfoBox: { textAlign: 'center' },
  moreInfoButton: { background: '#7C3AED', color: 'white', border: 'none', padding: '13px 22px', borderRadius: 12, fontSize: '1rem', fontWeight: 800, cursor: 'pointer' },

  contentGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 28, alignItems: 'start' },
  textBlock: { background: '#F9FAFB', padding: 28, borderRadius: 24, boxShadow: '0 10px 30px rgba(0,0,0,0.06)', lineHeight: 1.7 },
  sectionTitle: { color: '#7C3AED', fontSize: '2rem', marginTop: 0 },
  notice: { background: '#EDE9FE', color: '#5B21B6', borderLeft: '5px solid #7C3AED', padding: 16, borderRadius: 12, marginTop: 22, fontWeight: 700 },
  form: { background: 'white', padding: 28, borderRadius: 24, boxShadow: '0 15px 45px rgba(0,0,0,0.1)', display: 'grid', gap: 18 },
  formTitle: { color: '#7C3AED', margin: 0, fontSize: '1.8rem' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 },
  label: { display: 'block', fontWeight: 700, marginBottom: 7 },
  input: { width: '100%', padding: 13, borderRadius: 12, border: '1px solid #D1D5DB', fontSize: '1rem', boxSizing: 'border-box' },
  parentBox: { background: '#FFF7ED', border: '1px solid #FDBA74', borderRadius: 18, padding: 18, display: 'grid', gap: 16 },
  parentTitle: { margin: 0, color: '#C2410C' },
  checkboxLine: { display: 'flex', alignItems: 'flex-start', gap: 10, lineHeight: 1.4 },
  submitButton: { background: '#7C3AED', color: 'white', border: 'none', padding: '15px 20px', borderRadius: 14, fontSize: '1rem', fontWeight: 800, cursor: 'pointer' },
  success: { background: '#DCFCE7', color: '#166534', padding: 14, borderRadius: 12, fontWeight: 700 },
};

export default CrewAudition;